import { Tooltip, Typography } from "antd";
import React from "react";
import styled from "styled-components";
import Checkbox from "../../Common/Components/Checkbox";
import { WFStatusEnum } from "../../Automation/interfaces";

interface IDropdownListItemProps {
  itemName: string;
  itemId?: string;
  selectedItems?: Array<any>;
  listParent?: string;
  allCampaignsSelected?: boolean;
  sentBy?: string;
  emailsDD?: boolean;
  checkboxHanlder(): void;
  itemParentName?: string;
  dateTime?: string;
  isChip: boolean;
}
export const DropdownListItem: React.FC<IDropdownListItemProps> = ({
  itemName,
  itemId,
  selectedItems,
  listParent,
  sentBy,
  allCampaignsSelected,
  emailsDD,
  checkboxHanlder,
  itemParentName,
  dateTime,
  isChip,
}) => {
  const { Paragraph } = Typography;
  const tooltip = <div>{itemName}</div>;

  return (
    <Div className={`d-flex flex-row align-items-start`} id={`dropdown-item-${itemId}`}>
      <Checkbox alignSelf checked={selectedItems?.includes(itemId)} onChange={checkboxHanlder} />
      <div>
        <Tooltip title={itemName?.length > 25 ? itemName : undefined}>
          {itemParentName && (
            <Paragraph
              className={`templates 
            ${isChip ? (itemParentName === WFStatusEnum.ACTIVE ? "activeChip" : "inactiveChip") : ""}`}
            >
              {itemParentName}
            </Paragraph>
          )}
          <Paragraph className={`label template-subject ${isChip ? "" : "pt-02"} mb-n5`}>{itemName}</Paragraph>
        </Tooltip>
        {sentBy && (
          <div className="sent-by">
            Sent by:
            <Tooltip
              title={sentBy?.length > 10 ? sentBy : undefined}
              getPopupContainer={() => document.querySelectorAll(`.${listParent}`)[1] as HTMLElement}
            >
              <Paragraph className={`email`}>{sentBy}</Paragraph>
              {/* <Paragraph className={`email`}>lgill@xiqinc.com</Paragraph> */}
              <Paragraph className={`date`}>{dateTime}</Paragraph>
              {/* <p>{sentBy}</p> */}
            </Tooltip>
          </div>
        )}
      </div>
    </Div>
  );
};

export default React.memo(DropdownListItem);

const Div = styled.div`
  margin-bottom: 20px;
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  div:first-child {
    align-self: flex-start;
    margin-top: 0;
  }
  .mb-n5 {
    margin-bottom: -5px !important;
  }
  .template-subject {
    padding: 0 0 2px 0 !important;
    line-height: 1 !important;
    color: #67696a !important;
  }
  .pt-02 {
    padding-top: 2px !important;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding-top: 0px !important;
    }
  }
  .templates {
    font-family: "Roboto";
    font-weight: 500;
    color: rgba(109, 109, 109, 0.7);
    font-size: 12px;
    // display: -webkit-inline-box;
    line-height: 1;
    margin-bottom: 0;
    padding-top: 2px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
  .activeChip {
    background: #1ec252;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    width: max-content;
  }
  .inactiveChip {
    border: 1px solid #1ec252;
    color: #1ec252;
    padding: 2px 8px;
    border-radius: 12px;
    width: max-content;
  }
  .sent-by {
    margin-top: -20px;
    font-family: "Roboto";
    color: #67696a;
    font-weight: 500;
    font-size: 10px;
    // display: inline-flex;
    display: -webkit-inline-box;
    span {
      display: flex;
      /* margin-bottom: 20px; */
    }
    .email {
      color: #67696a;
      padding-left: 5px;
      max-width: 100px; // if there is a large email address then it will contains it to 100px
      min-width: 100px; // if email address is less than 100px space then it will make sure that the email address should get 100px space
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-bottom: 0;
    }
    &:hover {
      cursor: pointer;
    }
    .date {
      color: #67696a;
      padding-left: 10px;
      margin-left: 10px;
      border-left: 1px solid #dddddd;
      max-width: 145px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-bottom: 0;
    }
  }
`;
